import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { SwPush } from "@angular/service-worker";
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public config = environment
  public baseUrl = this.config['baseWithAPI'];
  public host = this.config['host'];
  private gatesdata:any;
  private sharedData: any;
  private shareflightdata:any;
  private registration;
  public subscription;
  sessionId: any;
  errormessage:any ='';
  language: BehaviorSubject<any> = new BehaviorSubject(null);
  digitaltwingateData:BehaviorSubject<any> = new BehaviorSubject(null);
  callnotification:BehaviorSubject<any> = new BehaviorSubject(null);
  digitaltwinDatae:BehaviorSubject<any> = new BehaviorSubject(null);
  verifyapifailed: BehaviorSubject<any> = new BehaviorSubject(null);
  subscribervalue:BehaviorSubject<any> = new BehaviorSubject(null);
  isbaflight:BehaviorSubject<any> = new BehaviorSubject(null);
  constructor( private router: Router, private _http: HttpClient,private cookieservice: CookieService, private SwPush: SwPush, public device: DeviceDetectorService) {
  }


  getCounterDetails() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '1')
    return this._http.get<any>(this.baseUrl + '/AviLeap/checkincounter/allcounterlist', { headers: headers });
  }

  adrInnerVideo(parameters, langtype?) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', "2");
    headers = headers.append('Accept-Language', langtype);
    return this._http.get(this.baseUrl + '/AviLeap/boarding-status-pax', { params: parameters, headers: headers });

  }
  gates_api(param): Observable<any>{
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    params = params.set('gate', param);
    headers = headers.append('version', "2")
    return this._http.get<any>(this.host + "/ADR/digital-twin-gatewise",{params: params, headers: headers});
  }
  
  Autosearchapi(param): Observable<any>{
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    params = params.set('gate', param.fdata);
    if(param.search_by){
      params = params.set('search_by', param.search_by);
      params = params.set('airlines', param.airlines);
    }
    headers = headers.append('version', "2")
    return this._http.get<any>(this.host + "/ADR/autosuggest",{params: params, headers: headers});
  }



  // savesubscription(param){
  //   let headers = new HttpHeaders().set("Content-Type", "application/json");
  //   headers = headers.append('AUTHTYPE', 'COGNITO');
  //   headers = headers.append('version', "2")
  //   return this._http.post<any>(this.host + "/pax/savesubscription", param,{headers: headers});
  // }


  savesubscription(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    
    return this._http.post<any>(this.baseUrl + '/push-notification/subscription', param,{headers: headers});
  }

  callsavesubscription(value?){
    const notificationSubscriptionvalue = localStorage.getItem('notification');
    const subvalue = JSON.parse(localStorage.getItem('subvalue'));
    const randomid = localStorage.getItem('unique_Device_Id');
    const logid = sessionStorage.getItem('flight_logid');
    const params = {
      "sub_info": subvalue,
      "subscription_id": randomid,
      "flight_pk":logid ? parseInt(logid) : null
    }
    if(value){
      params['subscribed'] = notificationSubscriptionvalue == 'true' ? true : false
    }else{
      params['subscribed'] = notificationSubscriptionvalue == 'true' ? false : true
    }
    this.savesubscription(params).subscribe((res)=>{
      if(res){
        if(!value){
          this.setnotification(params['subscribed']);
        }
      }
    },(error)=>{
      console.log(JSON.stringify(error));
    })
  }

  async getsubscriptionvalue() {
    const subValue = localStorage.getItem('subvalue');
    const sub = JSON.parse(subValue);
    if (!sub) {
      const deviceType = this.device.os; // Get the device type (e.g., iOS, Android, etc.)
      try {
        let permission = await Notification.requestPermission();
          if( permission == 'default'){
           await Notification.requestPermission().then(res=>{
              if(res == 'granted'){
                permission = res
              }
            })
          }
          if (permission === 'granted') {
          // console.log("before registed"+new Date().toLocaleTimeString());
          this.registration = await navigator.serviceWorker.getRegistration();
          // console.log(JSON.stringify(this.registration));
          // alert(JSON.stringify(registration));
          if (this.registration) {
            // console.log("in registed"+new Date().toLocaleTimeString());
            this.subscription = await this.registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: this.config.publickey,
            }).catch((err)=>{
              // alert(JSON.stringify(err + 'reg failed'));
            });
            // console.log(JSON.stringify(this.subscription));
            // console.log("after sub registed"+new Date().toLocaleTimeString());
            if (this.subscription) {
              this.subscribervalue.next(this.subscription); // Update the subscription observable
              localStorage.setItem('subvalue', JSON.stringify(this.subscription)); // Save subscription to localStorage
              // console.log("after register"+new Date().toLocaleTimeString());
              this.callsavesubscription();
            }
          }
        } else {
          console.log('Notification permission not granted:', permission);
        }
      } catch (error) {
        console.error('Error during subscription:', error);
      }
    }
  }
  


  unsubvalue(){
    const subvalue = localStorage.getItem('subvalue');
    this.subscription = JSON.parse(subvalue);
    if(this.subscription){
      localStorage.removeItem('subvalue');
      localStorage.setItem('notification', 'false');
      this.subscription.unsubscribe();
    }
  }

  urlB64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }


  clicksearchapi(param): Observable<any>{
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    params = params.set('gate', param.fdata);
    if(param.search_by){
      params = params.set('search_by', param.search_by);
      params = params.set('flight_pk', param.airlines);
    }
    headers = headers.append('version', '2')
    return this._http.get<any>(this.host + "/ADR/searchinfolookup",{params: params, headers: headers});
  }

  getsession(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', "2")
    return this._http.post<any>(this.host + "/no-auth-pax-view-session",param,{headers: headers});
  }

  getallgates(){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    headers = headers.append('version', "2")
    return this._http.get<any>(this.host + "/ADR/peer-gates",{params: params, headers: headers});
  }

  nextpagelinks(link){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', "2")
    return this._http.get<any>(link,{headers: headers});
  }

  watchcountapi(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', "2")
    return this._http.post<any>(this.host + "/pax/refresh-update ", param,{headers: headers});
  }

  setSharedData(data: any): void {
    this.sharedData = data;
  }

  setsearchedflightdta(data){
    sessionStorage.setItem('SearchedFlight_data', JSON.stringify(data))
    this.shareflightdata = data;
  }
  getflightshareddata(){
    let data = sessionStorage.getItem('SearchedFlight_data');
    data = JSON.parse(data)
    return data ? data : this.shareflightdata;
  }
  getSharedData(): any {
    return this.sharedData;
  }

  seterrormessage(data){
    this.errormessage = data
  }

  geterrormessage(){
    return this.errormessage;
  }

  setsessionId(key: string, value: any, expiryInHours: number): void {
    const now = new Date();
    const expiryTime = now.getTime() + expiryInHours * 60 * 60 * 1000;
  
    const item = {
      value: value,
      expiry: expiryTime,
    };
  
    sessionStorage.setItem(key, JSON.stringify(item));
  }

  getsessionId(key:any){
    const itemString = sessionStorage.getItem(key);
    if (itemString) {
      const item = JSON.parse(itemString);
      if (item.expiry > Date.now()) {
        return item.value;
      } else {
        sessionStorage.removeItem(key);
        return null;
      }
    } else {
      return null;
    }
  }

  sendrating(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', "2")
    return this._http.post<any>(this.host + "/user-rating ", param,{headers: headers});
  }

  verifyapi(param) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', "2")
    return this._http.post<any>(this.host + "/verify-qr-session", param,{headers: headers});
  }
  
  setnotification(value){
    localStorage.setItem('notification', value)
    if(value == 'true'){
      this.SwPush.notificationClicks.subscribe(({action, notification}) => {
        if(action == 'Unsubscribe'){
          window.location.reload();
        }
        if(action == 'open'){
          this.router.navigate(notification.data.url);
        }
      });
      this.SwPush.messages.subscribe((res)=>{
        // console.log(res);
      })
    }
  }
  
}
